// Referral program (simplified). A friend who joins via your code starts as
// 'invited'; once they activate they grant ACTIVATION_BONUS_BIDS bonus bids and
// keep earning you bonus bids as they bid. Two visible states so the inviter can
// spot who hasn't activated yet and nudge them. No separate revshare stage. The
// backend doesn't exist yet — useReferral() serves a mock; swap its body for a
// real fetch when /api/referrals lands, the types stay.

export const ACTIVATION_BONUS_BIDS = 5;

export type ReferralStage = 'invited' | 'activated';

export type Referral = {
  id: string;
  // Display handle: '@username' when known, else a first name.
  name: string;
  // Telegram username (no @) for a direct link; null when the friend hides it.
  username: string | null;
  stage: ReferralStage;
  // Bonus bids earned from this friend so far. 0 while 'invited'; >= activation
  // bonus once 'activated', grows as they bid.
  bidsEarned: number;
};

export type ReferralSummary = {
  code: string;
  referrals: Referral[];
  totalEarned: number;
};

export function mockReferralSummary(code: string): ReferralSummary {
  const referrals: Referral[] = [
    { id: 'r1', name: '@cs_mike', username: 'cs_mike', stage: 'activated', bidsEarned: 42 },
    { id: 'r2', name: '@val_ks', username: 'val_ks', stage: 'activated', bidsEarned: 23 },
    { id: 'r3', name: 'Andrey', username: null, stage: 'activated', bidsEarned: 9 },
    { id: 'r4', name: '@trader7', username: 'trader7', stage: 'invited', bidsEarned: 0 },
    { id: 'r5', name: '@dust2', username: 'dust2', stage: 'invited', bidsEarned: 0 },
    { id: 'r6', name: '@karambit_fan', username: 'karambit_fan', stage: 'invited', bidsEarned: 0 },
    { id: 'r7', name: '@newguy', username: 'newguy', stage: 'invited', bidsEarned: 0 },
  ];
  return {
    code,
    referrals,
    totalEarned: referrals.reduce((sum, r) => sum + r.bidsEarned, 0),
  };
}
